<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            scrollable
            :width="salesOrders? 1150 : 500">
            <v-card>
                <v-card-title>
                    {{ $t("sales_order_search") }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <SalesOrdersDataTable
                        ref="salesOrdersDataTable"
                        :loading="loading"
                        :salesOrders="salesOrders"
                        :length="salesOrdersLength"
                        :pagination="true"
                        @updated="getSalesOrders"
                        @selected:row="setSelectedSalesOrder"
                        @selected:clear="clearSelectedSalesOrder"
                        />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="submit"
                        >
                        {{ $t("add_btn") }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t("close_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SalesOrdersDataTable from '../Sales/SalesOrdersDataTable';
import { mapActions } from 'vuex';
import {isEmpty} from 'lodash';

export default {
    name: "SalesOrderSearchDialog",
    components: {
        SalesOrdersDataTable
    },
    props: {
        display: {
            type: Boolean,
            required: true
        },
        customerId: {
            type: Number,
            required: false
        },
        search: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loading: false,
            salesOrdersLength: 0,
            selectedSalesOrder: {}
        }
    },
    computed: {
        hasSelectedSalesOrder() {
            return !isEmpty(this.selectedSalesOrder);
        }
    },
    methods: {
        ...mapActions("sales/salesOrder", ["fetchSalesOrders"]),
        close() {
            this.$emit("close");
        },
        submit() {
            this.$emit("submit", this.selectedSalesOrder);
        },
        async getSalesOrders(options = {itemsPerPage: 10}) {
            this.loading = true;
            options =  {customer_id: this.customerId, search: this.search, ...options};
            var result = await this.fetchSalesOrders(options);
            this.salesOrders = result.data.data;
            this.salesOrdersLength = result.data.total;
            this.loading = false;
        },
        setSelectedSalesOrder(salesOrder) {
            this.selectedSalesOrder = salesOrder;
        },
        clearSelectedSalesOrder() {
            this.selectedSalesOrder = {}
        },
    },
    created() {
        this.getSalesOrders();
    }
}
</script>